import { render, staticRenderFns } from "./AboutDepartmentsTrainings.vue?vue&type=template&id=f50f9d00&scoped=true&"
import script from "./AboutDepartmentsTrainings.vue?vue&type=script&lang=js&"
export * from "./AboutDepartmentsTrainings.vue?vue&type=script&lang=js&"
import style0 from "./AboutDepartmentsTrainings.vue?vue&type=style&index=0&id=f50f9d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50f9d00",
  null
  
)

export default component.exports